// extracted by mini-css-extract-plugin
module.exports = {"profile":"Profile_profile__pyPng","header":"Profile_header__2hkai","des":"Profile_des__2pA-f","details":"Profile_details__1aSYB","profileClose":"Profile_profileClose__cFToP"};